import i18n from 'src/features/i18n';

export default (bool) => (bool ? i18n.t('T_YES') : i18n.t('T_NO'));
